import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommand = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M7.75 7.75h4.5m-4.5 0v4.5m0-4.5v-3a3 3 0 1 0-3 3h3Zm4.5 0v4.5m0-4.5h3a3 3 0 1 0-3-3v3Zm0 4.5h-4.5m4.5 0h3a3 3 0 1 1-3 3v-3Zm-4.5 0h-3a3 3 0 1 0 3 3v-3Z"
	})]
});
const ForwardRef = forwardRef(SvgCommand);
export { ForwardRef as ReactComponent };
